import React from 'react'
import { LabelComponentBuilder } from '../../store/itinerary/routes.utils'

export const extractNumber = (label = '') => {
  const firstNonDigit = label.search(/\D/)
  if (firstNonDigit === -1) return label.length > 0 && /^\d/.test(label) ? [label, ''] : [label]
  if (firstNonDigit === 0) return [label]
  return [label.slice(0, firstNonDigit), label.slice(firstNonDigit)]
}

const StepUpNumber = ({ label, mainClassName, restClassName }) => {
  const formatted = extractNumber(label)
  return (
    <>
      <span className={mainClassName}>{formatted[0]}</span>
      <span className={restClassName}>{formatted[1]}</span>
    </>
  )
}

export const buildStepUpComponents = (label) => {
  const formatted = extractNumber(label)
  const components = [LabelComponentBuilder.text(formatted[0])]
  if (formatted[1]) components.push(LabelComponentBuilder.text(formatted[1], undefined, 'small'))
  return components
}

export default StepUpNumber
